// Whether a media query matches now, kept up to date.
import { useSyncExternalStore } from 'react';

export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (changed) => {
      const list = window.matchMedia(query);
      list.addEventListener('change', changed);
      return () => list.removeEventListener('change', changed);
    },
    () => window.matchMedia(query).matches,
    () => false,
  );
}

/** A desktop's width: the sidebar shows from here. */
export const DESKTOP = '(min-width: 1024px)';
